import { httpGetUserFields } from '@iconik-io/iconik-api/src/services/metadata';

import type { AppDispatch, GetState } from '../../store/types';
import { selectUserRoles } from '../../utils/get_user_roles';

export const getMetadataUserFields =
  () =>
  (dispatch: AppDispatch, getState: GetState): Promise<unknown> => {
    const userRoles = selectUserRoles(getState());
    if (!userRoles.canReadMetadataFields) {
      return Promise.resolve();
    }
    return dispatch(httpGetUserFields());
  };
